import { curityTokenParams } from 'consts/curity';
import { queryParams, tokenData } from 'helpers';
import { useAMLStatus } from 'hooks/useAMLStatus';
import { AppContext } from 'providers/AppContext';
import { useContext, useEffect } from 'react';
import { userAction } from 'store/actions';

export function Curity() {
	const ctx = useContext(AppContext);
	const { config, dispatch, navigate, state } = ctx;
	const { CURITY_CLIENT_ID, CURITY_CLIENT_SECRET, CURITY_OAUTH_TOKEN_URL } = config;
	const { user } = state;

	useEffect(() => {
		const [code] = queryParams('code');
		if (code) {
			fetch(CURITY_OAUTH_TOKEN_URL, {
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: new URLSearchParams(curityTokenParams(CURITY_CLIENT_ID, CURITY_CLIENT_SECRET, code)),
				method: 'post'
			})
				.then(res => res.json())
				.then(data => {
					const token = tokenData(data.access_token);
					if (token) {
						dispatch([
							userAction,
							{
								user: {
									...user,
									token: data.access_token
								}
							}
						]);
					}
				});
		} else {
			navigate(`../${user.flowType || 'mv'}/authenticate`);
		}
	}, [CURITY_CLIENT_ID, CURITY_CLIENT_SECRET, CURITY_OAUTH_TOKEN_URL, user]); // eslint-disable-line react-hooks/exhaustive-deps

	useAMLStatus();
	return null;
}
